import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { VersionContext } from "views/Account/Module/Version/Context";

import { ModuleVersionTestCaseRow } from "../types";

const ModuleVersionTestCasesTableNameCell = ({
  item: testCase,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionTestCaseRow>) => {
  const { module, version } = useTypedContext(VersionContext);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/module/${module.id}/version/${version.id}/run/${testCase.id}`}>
        {testCase.expectFailure ? `${testCase.title} (should fail)` : testCase.title}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModuleVersionTestCasesTableNameCell;
